import { theme } from "antd";
import ConfigProvider from "antd/lib/config-provider";
import Table from "antd/lib/table";
import classNames from "classnames";
import EmptyTableResult from "rivals/components/shared/Tables/EmptyTableResult";
import styles from "rivals/components/shared/Tables/index.module.scss";
import { setData } from "rivals/shared/utils/qa";
import { Props } from "./types";

const DEFAULT_TABLE_X_SCROLL_LIMIT = 960;
const TWO = 2;

const RivalsTable = <T extends {}>({
  className,
  columns,
  data,
  emptyTable,
  expandableProps,
  onChange,
  philter,
  rowKey,
  stripedRows = false,
  tableKey,
  title,
  xScrollLimit
}: Props<T>): JSX.Element => {
  const token = theme.useToken();
  const defaultEmptyTable = <EmptyTableResult />;

  return (
    <ConfigProvider
      renderEmpty={(): JSX.Element => emptyTable || defaultEmptyTable}
      theme={token}
    >
      <Table<T>
        className={classNames(className, styles.table, {
          [styles.emptyTable]: !data || !data.length
        })}
        columns={columns}
        dataSource={data}
        expandable={expandableProps || {}}
        key={tableKey}
        onChange={onChange}
        pagination={false}
        rowClassName={(_, index): string => {
          return index % TWO === 1 && stripedRows ? styles.darkRow : "";
        }}
        rowKey={rowKey}
        {...setData(philter, "table")}
        scroll={{ x: xScrollLimit || DEFAULT_TABLE_X_SCROLL_LIMIT }}
        tableLayout="fixed"
        title={title}
      />
    </ConfigProvider>
  );
};

export default RivalsTable;
